module.exports = __webpack_public_path__ + "img/BAU Future_Infographics_2.dcd97a81.png";